import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';

import { useDispatch, useSelector } from 'react-redux';
import { CustomGroupUtils, PhoneUtil } from 'utils';

import { NavLink, useParams } from 'react-router-dom';

import 'shared/ProfileControls.scss';
import { ActivityPopup } from 'shared/forms/NewActivity';
import { TextMessageModal } from 'shared/modals';
import TextIcon from 'shared/TextIcon';
import EmailIcon from 'shared/EmailIcon';
import { BannedIcon } from 'dyl-components';

const Controls = () => {
    const {
        phone,
        call_suspended,
        mainPhone,
        account_id,
        userPhoneCreds,
        name,
        hasEmail,
        dialerContactID,
        isMainPhoneDuplicate,
    } = useSelector(state => {
        const { first_name, last_name, suffix } = state.contact.contact || {};
        const custom_data = {};
        const contact_custom = state.contact.custom_data;
        contact_custom.fields.forEach(field => {
            custom_data[`fields|${field.field_name}`] = field.value;
        })
        const name = `${first_name || ''} ${last_name || ''}${suffix ? ` ${suffix}` : ''}`;
        const contactEmails = state.contact.email ? state.contact.email.slice(0).map(({ email }) => email) : [];

        let mainPhone = state.contact_phone.phone.find(item => item.main);
        let mainEmail = state.contact_email.email.find(item => item.main);

        if (!mainPhone) {
            mainPhone = state.contact.phone[0] || { phone: '' }
        }

        if (!mainEmail) {
            mainEmail = state.contact.email[0] || { email: '' }
        }

        const { master_source, secondary_source, campaign_converted } = state.contact.current_stage || {};
        
        return {
            name,
            phone: state.contact_phone.phone.length > 0 ? `${mainPhone?.phone}` : "", 
            call_suspended: mainPhone?.call_suspended,
            integration_id: state.oauth_integrations?.activeIntegration?.id,
            mainPhone: mainPhone.phone,
            isMainPhoneDuplicate : mainPhone.duplicate_contact_id,
            parent_account: state.contact.account,
            current_pipeline_category: state.contact.current_stage?.pipeline_category_id,
            account_stage: state.contact.current_stage?.account_stage || "contact",
            master_source,
            secondary_source: secondary_source?.id || null,

            module_custom_data: CustomGroupUtils.groupAndFlatten(state.contact.current_stage?.custom_data || {}),

            campaign_converted: campaign_converted && Object.keys(campaign_converted).length > 1 && (Boolean(campaign_converted.id) && Boolean(campaign_converted.name)) ? campaign_converted.id : null,
            account_id: state.contact.account_id,
            primary_contact_id: state.contact.account.primary_contact_id,
            isCustomerAccount: state.contact.account.has_customer,
            userPhoneCreds: state?.officeView?.creds,
            hasEmail: contactEmails.length > 0 && !mainEmail.duplicate_contact_id,
            dialerContactID: state.officeView?.dialer?.contact_id
        }
    });    
    const dispatch = useDispatch();
    const isPhoneSystemSupported = PhoneUtil.isPhoneSystemSupported(userPhoneCreds);

    const { contact_id } = useParams();
    const locationParam = () => `contact/${contact_id}`;

    const [openForm, setOpenForm] = useState(null);
    const onCloseForm = () => {
        setOpenForm(null);
    }

    const isContactInDialer = dialerContactID && Number(dialerContactID) === Number(contact_id);
    const isPhoneDisable =  !phone || isContactInDialer || isMainPhoneDuplicate;
    return (
        <React.Fragment>
            {isPhoneSystemSupported ? (
                !call_suspended ? (
                    <Icon
                        disabled={isPhoneDisable}
                        onClick={() => {
                        if (!isPhoneDisable) {
                                PhoneUtil.C2D({
                                    payload: {
                                        contact_id: Number(contact_id) || null,
                                        account_id: Number(account_id) || null,
                                        destination: mainPhone,
                                    },
                                    dispatch,
                                });
                        }
                        }}
                        className="Profile__controls fas fa-phone"
                        link
                    />
                ) : (
                    <BannedIcon 
                        iconName='fas fa-phone'
                        iconClassName='Profile__controls'
                        banIconSize='tiny'
                    />
                )
            ) : (
                <ActivityPopup
                    trigger={
                        <Icon
                            disabled={!phone || isMainPhoneDuplicate}
                            className="Profile__controls fas fa-phone"
                            link
                        />
                    }
                    activityProps={{
                        contact: { id: Number(contact_id) },
                        isContact: true,
                        hideActivitySelection: true
                    }}
                    open={openForm === 'call'}
                    onOpen={() => setOpenForm('call')}
                    onClose={onCloseForm}
                    position="bottom right"
                />
            )}
            <TextIcon
                account_id={account_id}
                contact_id={contact_id}
                isActivityFormOpen={openForm === 'text'}
                onCloseActivityForm={onCloseForm}
                onOpenActivityForm={() => { setOpenForm('text') }}
                onOpenTextModal={() => { setOpenForm('text-modal') }}
                phone={mainPhone}
                iconClassName="Profile__controls"
                disabled={isMainPhoneDuplicate}
            />
            <EmailIcon 
                hasEmail={hasEmail}
                contact_id={contact_id}
                emailIconClassName={'Profile__controls'}
                onOpenEmailModal={() => {setOpenForm('email-modal')}}
                isEmailModalOpen={openForm === 'email-modal'}
                isActivityFormOpen={openForm === 'email'}
                onOpenActivityPopup={() => {setOpenForm('email')}}
                onClose={onCloseForm}
            />
            <Icon
                as={NavLink}
                to={`/${locationParam()}/notes`}
                link
                className="Profile__controls fa-sharp fa-solid fa-pen-clip"
                color="grey"
            />
            <TextMessageModal
                open={openForm === 'text-modal'}
                onClose={onCloseForm}
                contact_name={name}
                contact_id={contact_id}
            />
        </React.Fragment>
    );
};

export default Controls;

